import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";
import { patientTermPostProcessor } from "./shared/i18n/patientTerm";

i18n
    .use(LanguageDetector)
    .use(patientTermPostProcessor)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            es: { translation: es },
        },
        fallbackLng: "en",
        // Rewrite the "patient/paciente" term to the therapist's chosen label.
        postProcess: ["patientTerm"],
        interpolation: {
            escapeValue: false,
        },
    });

/**
 * Tell the browser which language the page is actually in.
 *
 * `index.html` can only declare one language, and i18next picks another at
 * runtime for every Spanish therapist and patient. A Spanish page declared as
 * English is what makes Chrome offer — and on Android often silently apply —
 * a translation, and Google Translate replaces the text nodes React still
 * holds references to. React then inserts a sibling before a node it no
 * longer owns, the render dies with `NotFoundError: insertBefore`, and the
 * page goes with it. Keeping `lang` honest removes the reason to translate
 * in the first place.
 */
const applyDocumentLanguage = (language: string) => {
    if (typeof document === "undefined") return;
    document.documentElement.lang = language.split("-")[0];
};

applyDocumentLanguage(i18n.resolvedLanguage ?? i18n.language ?? "en");
i18n.on("languageChanged", applyDocumentLanguage);

export default i18n;
